export const MessageArgsToType = <T>(args: unknown[]): T => {
    if (args.length !== 1) {
        throw new Error(
            "Unable to convert message to type, unexpected amount of arguments",
        );
    }

    return args[0] as T;
};
